import { Injectable, NgZone } from '@angular/core';
import { auth } from 'firebase/app';
import { User } from "../user";
import { Router } from "@angular/router";
import { AngularFireAuth } from "@angular/fire/auth";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  user: User;
  private userDetails: firebase.User = null;
  
  constructor(
      public router: Router,
      public ngZone: NgZone,
      public afAuth: AngularFireAuth,
      private angularFireAuth: AngularFireAuth
  ) {
      /* this.afAuth.authState.subscribe(user => {
        this.user = user;
        console.log('this.user',this.user);
      }) */
      this.afAuth.authState.subscribe(
          (user) => {
              if(user){
                this.user = user;
                this.userDetails = user;
                console.log('this.user',this.user);
                }
                else{
                 this.userDetails = null;
                }
      })
  }

  // Firebase SignInWithPopup
  OAuthProvider(provider) {
    return this.afAuth.auth.signInWithPopup(provider)
        .then((res) => {
            this.ngZone.run(() => {
                this.router.navigate(['/']);
            })
        }).catch((error) => {
            window.alert(error)
        })
  }

  // Firebase Google Sign-in
  SigninWithGoogle(returnUrl) {
      return this.OAuthProvider(new auth.GoogleAuthProvider())
          .then(res => {
                this.router.navigate([returnUrl]);
                console.log('Successfully logged in!')
          }).catch(error => {
              console.log(error)
          });
  }

  // Firebase Logout 
  SignOut() {
      return this.afAuth.auth.signOut().then(() => {
          this.router.navigate(['login']);
      })
  }

  isLoggedIn() {
      // console.log('this.user',this.user);
    if (this.userDetails == null ) {
        console.log('not login');
        return false;
      } else {
        console.log('login');
        return true;
      }
  }
}
